import * as _ from 'lodash'

// fields posted from Conifer app - patient biometrics and other metadata
const coniferFields = [
    'KEY',
    'LANGUAGE',
    'PARTICIPANT_ID',
    'EXTERNAL_PLAN_ID',
    'PARTICIPANT_RESEARCH_OPTIN',
    'GENDER',
    'DOB',
    'SURVEY_ID',
    'EXTERNAL_SURVEY_ID',
    'MEDS_ANGINA',
    'MEDS_BP',
    'MEDS_CHOL',
    'MEDS_DM',
    'PMH_CVD',
    'PMH_HTN',
    'PMH_CHOL',
    'PMH_DM',
    'BP_SYS',
    'BP_DIA',
    'WEIGHT',
    'HEIGHT_FT',
    'HEIGHT_IN',
    'WAIST',
    'TCHOL',
    'LDL',
    'HDL',
    'TRIG',
    'FASTING_BG',
    'A1C',

    'SMOKE_STAT',
    'SMOKE_QUIT',
    'SMOKE_CIGS',

    'PA_MOD_FREQ',
    'PA_MOD_DUR',
    'PA_HI_FREQ',
    'PA_HI_DUR',
    'SED_HRS',
    'SED_VIDEO',
    'SED_COMPUTER',

    'STRESS_WORRIES',
    'STRESS_HECTIC',
    'STRESS_NO_TIME',
    'STRESS_COMPETE',
    'STRESS_AUTONOMY',
    'STRESS_NERVOUS',
    'STRESS_ANGER',
    'STRESS_ARGUES',
    'STRESS_ANNOYED',
    'STRESS_SUPPRESSED',
    'STRESS_TEMPER',
    'STRESS_PLEASURE',
    'STRESS_ANXIETY',
    'STRESS_DEPRESSED',

    'DIET_VEGGIES',
    'DIET_FRUITS',
    'DIET_WW_GRAINS',
    'DIET_LF_DAIRY',
    'DIET_FF_DAIRY',
    'DIET_EGGS',
    'DIET_BEANS',
    'DIET_SEAFOOD',
    'DIET_POULTRY',
    'DIET_MEAT',
    'DIET_SNACKS',
    'DIET_FRIED',
    'DIET_PASTRY',
    'DIET_EAT_OUT',
    'DIET_HEALTH_FOOD',
    'DIET_TYPE_OF_FAT',
    'DIET_COOKING_FATS',
    'DIET_TABLE_FATS',
]


// define a set of test cases - values for coniferFields
var base = {
    KEY: 'aaa',
    LANGUAGE: 'en',
    PARTICIPANT_ID: null,
    EXTERNAL_PLAN_ID: '123',
    PARTICIPANT_RESEARCH_OPTIN: '',
    GENDER: 'M',
    DOB: '1980-01-02',
    SURVEY_ID: '',
    EXTERNAL_SURVEY_ID: '',
    MEDS_ANGINA: '',
    MEDS_BP: '',
    MEDS_CHOL: '',
    MEDS_DM: '',
    PMH_CVD: '',
    PMH_HTN: '',
    PMH_CHOL: '',
    PMH_DM: '',
    BP_SYS: '120',
    BP_DIA: '80',
    WEIGHT: '180',
    HEIGHT_FT: '5',
    HEIGHT_IN: '10',
    WAIST: '32',
    TCHOL: '150',
    LDL: '110',
    HDL: '40',
    TRIG: '77',
    FASTING_BG: '88',
    A1C: '99',

    SMOKE_STAT: 'r_0',
    SMOKE_QUIT: 'r_0',
    SMOKE_CIGS: 'r_0',

    PA_MOD_FREQ: 'r_0',
    PA_MOD_DUR: 'r_0',
    PA_HI_FREQ: 'r_0',
    PA_HI_DUR: 'r_0',
    SED_HRS: 'r_0',
    SED_VIDEO: 'r_0',
    SED_COMPUTER: 'r_0',

    STRESS_WORRIES: 'r_0',
    STRESS_HECTIC: 'r_0',
    STRESS_NO_TIME: 'r_0',
    STRESS_COMPETE: 'r_0',
    STRESS_AUTONOMY: 'r_0',
    STRESS_NERVOUS: 'r_0',
    STRESS_ANGER: 'r_0',
    STRESS_ARGUES: 'r_0',
    STRESS_ANNOYED: 'r_0',
    STRESS_SUPPRESSED: 'r_0',
    STRESS_TEMPER: 'r_0',
    STRESS_PLEASURE: 'r_0',
    STRESS_ANXIETY: 'r_0',
    STRESS_DEPRESSED: 'r_0',

    DIET_VEGGIES: 'r_0',
    DIET_FRUITS: 'r_0',
    DIET_WW_GRAINS: 'r_0',
    DIET_LF_DAIRY: 'r_0',
    DIET_FF_DAIRY: 'r_0',
    DIET_EGGS: 'r_0',
    DIET_BEANS: 'r_0',
    DIET_SEAFOOD: 'r_0',
    DIET_POULTRY: 'r_0',
    DIET_MEAT: 'r_0',
    DIET_SNACKS: 'r_0',
    DIET_FRIED: 'r_0',
    DIET_PASTRY: 'r_0',
    DIET_EAT_OUT: 'r_0',
    DIET_HEALTH_FOOD: 'r_0',
    DIET_TYPE_OF_FAT: 'r_0',
    DIET_COOKING_FATS: 'r_0',
    DIET_TABLE_FATS: 'r_0',
}

var reallySick = _.extend({}, base, {
    MEDS_ANGINA: 'yes',
    MEDS_BP: 'yes',
    MEDS_CHOL: 'yes',
    MEDS_DM: 'yes',
    PMH_CVD: 'yes',
    PMH_HTN: 'yes',
    PMH_CHOL: 'yes',
    PMH_DM: 'yes',
    BP_SYS: '200',
    BP_DIA: '150',
    WEIGHT: '400',
    HEIGHT_FT: '5',
    HEIGHT_IN: '10',
    WAIST: '52',
    TCHOL: '300',
    LDL: '290',
    HDL: '10',
    TRIG: '300',
    FASTING_BG: '200',
    A1C: '10'
});
var testBaseF = _.extend({}, base, {
    PARTICIPANT_ID: null, //'26639',
    EXTERNAL_PLAN_ID: '14128',
    DOB: '1959-02-26',
    GENDER: 'F'
});
var testBaseM = _.extend({}, base, {
    PARTICIPANT_ID: null, //'26624',
    EXTERNAL_PLAN_ID: '14128',
    DOB: '1977-10-20',
    GENDER: 'M'
});
var test1 = _.extend({}, testBaseF, {
    'EXTERNAL_SURVEY_ID': '1',
    MEDS_ANGINA: 'yes', MEDS_BP: 'yes', MEDS_CHOL: 'yes', MEDS_DM: 'no',
    PMH_CVD: 'no', PMH_HTN: 'yes', PMH_CHOL: 'yes', PMH_DM: 'yes',
    BP_SYS: '90', BP_DIA: '60', WEIGHT: '110', HEIGHT_FT: '0', HEIGHT_IN: '79', WAIST: '35',
    TCHOL: '172', LDL: '151', HDL: '21', TRIG: '120', FASTING_BG: '210', A1C: '5.5',
    "DIET_VEGGIES": "r_0", "DIET_FRUITS": "r_2", "DIET_WW_GRAINS": "r_3", "DIET_LF_DAIRY": "r_0",
    "DIET_FF_DAIRY": "r_3", "DIET_EGGS": "r_1", "DIET_BEANS": "r_3", "DIET_SEAFOOD": "r_2",
    "DIET_POULTRY": "r_2", "DIET_MEAT": "r_3", "DIET_SNACKS": "r_1", "DIET_FRIED": "r_0",
    "DIET_PASTRY": "r_1", "DIET_EAT_OUT": "r_1", "DIET_HEALTH_FOOD": "r_1",
    "STRESS_PLEASURE": "r_4", "STRESS_DEPRESSED": "r_3", "STRESS_NERVOUS": "r_1", "STRESS_WORRIES": "r_1",
    "STRESS_ANXIETY": "r_3", "STRESS_ANGER": "r_4", "STRESS_COMPETE": "r_2", "STRESS_NO_TIME": "r_4",
    "STRESS_ARGUES": "r_1", "STRESS_ANNOYED": "r_1", "STRESS_SUPPRESSED": "r_4", "STRESS_TEMPER": "r_1",
    "STRESS_AUTONOMY": "r_0", "STRESS_HECTIC": "r_0",
    "PA_HI_FREQ": "r_5", "PA_HI_DUR": "r_3", "PA_MOD_FREQ": "r_5", "PA_MOD_DUR": "r_6",
    "SED_HRS": "r_1", "SED_VIDEO": "r_3", "SED_COMPUTER": "r_5",
});
var test2 = _.extend({}, testBaseM, {
    'EXTERNAL_SURVEY_ID': '2',
    MEDS_ANGINA: 'no', MEDS_BP: 'yes', MEDS_CHOL: 'no', MEDS_DM: 'no',
    PMH_CVD: 'yes', PMH_HTN: 'no', PMH_CHOL: 'yes', PMH_DM: 'yes',
    BP_SYS: '110', BP_DIA: '90', WEIGHT: '130', HEIGHT_FT: '0', HEIGHT_IN: '77', WAIST: '36',
    TCHOL: '173', LDL: '152', HDL: '21', TRIG: '150', FASTING_BG: '200', A1C: '6.6',
    "DIET_VEGGIES": "r_2", "DIET_FRUITS": "r_1", "DIET_WW_GRAINS": "r_3", "DIET_LF_DAIRY": "r_1",
    "DIET_FF_DAIRY": "r_3", "DIET_EGGS": "r_0", "DIET_BEANS": "r_2", "DIET_SEAFOOD": "r_0",
    "DIET_POULTRY": "r_3", "DIET_MEAT": "r_3", "DIET_SNACKS": "r_2", "DIET_FRIED": "r_3",
    "DIET_PASTRY": "r_2", "DIET_EAT_OUT": "r_2", "DIET_HEALTH_FOOD": "r_3",
    "STRESS_PLEASURE": "r_4", "STRESS_DEPRESSED": "r_3", "STRESS_NERVOUS": "r_2", "STRESS_WORRIES": "r_3",
    "STRESS_ANXIETY": "r_2", "STRESS_ANGER": "r_1", "STRESS_COMPETE": "r_2", "STRESS_NO_TIME": "r_2",
    "STRESS_ARGUES": "r_4", "STRESS_ANNOYED": "r_4", "STRESS_SUPPRESSED": "r_2", "STRESS_TEMPER": "r_3",
    "STRESS_AUTONOMY": "r_1", "STRESS_HECTIC": "r_4",
    "PA_HI_FREQ": "r_1", "PA_HI_DUR": "r_6", "PA_MOD_FREQ": "r_2", "PA_MOD_DUR": "r_2",
    "SED_HRS": "r_3", "SED_VIDEO": "r_5", "SED_COMPUTER": "r_1",
});

var test3 = _.extend({}, testBaseF, {
    'EXTERNAL_SURVEY_ID': '3',
    MEDS_ANGINA: 'no', MEDS_BP: 'no', MEDS_CHOL: 'no', MEDS_DM: 'no',
    PMH_CVD: 'no', PMH_HTN: 'no', PMH_CHOL: 'no', PMH_DM: 'yes',
    BP_SYS: '130', BP_DIA: '120', WEIGHT: '170', HEIGHT_FT: '0', HEIGHT_IN: '75', WAIST: '37',
    TCHOL: '184', LDL: '153', HDL: '31', TRIG: '180', FASTING_BG: '190', A1C: '7.7',
    "DIET_VEGGIES": "r_2", "DIET_FRUITS": "r_3", "DIET_WW_GRAINS": "r_0", "DIET_LF_DAIRY": "r_0",
    "DIET_FF_DAIRY": "r_2", "DIET_EGGS": "r_2", "DIET_BEANS": "r_3", "DIET_SEAFOOD": "r_1",
    "DIET_POULTRY": "r_0", "DIET_MEAT": "r_3", "DIET_SNACKS": "r_0", "DIET_FRIED": "r_0",
    "DIET_PASTRY": "r_3", "DIET_EAT_OUT": "r_2", "DIET_HEALTH_FOOD": "r_0",
    "STRESS_PLEASURE": "r_2", "STRESS_DEPRESSED": "r_3", "STRESS_NERVOUS": "r_3", "STRESS_WORRIES": "r_1",
    "STRESS_ANXIETY": "r_1", "STRESS_ANGER": "r_2", "STRESS_COMPETE": "r_4", "STRESS_NO_TIME": "r_2",
    "STRESS_ARGUES": "r_3", "STRESS_ANNOYED": "r_3", "STRESS_SUPPRESSED": "r_0", "STRESS_TEMPER": "r_2",
    "STRESS_AUTONOMY": "r_3", "STRESS_HECTIC": "r_1",
    "PA_HI_FREQ": "r_5", "PA_HI_DUR": "r_1", "PA_MOD_FREQ": "r_0", "PA_MOD_DUR": "r_6",
    "SED_HRS": "r_4", "SED_VIDEO": "r_3", "SED_COMPUTER": "r_2",
});
var test4 = _.extend({}, testBaseM, {
    'EXTERNAL_SURVEY_ID': '4',
    MEDS_ANGINA: 'yes', MEDS_BP: 'no', MEDS_CHOL: 'yes', MEDS_DM: 'yes',
    PMH_CVD: 'no', PMH_HTN: 'no', PMH_CHOL: 'no', PMH_DM: 'no',
    BP_SYS: '150', BP_DIA: '110', WEIGHT: '190', HEIGHT_FT: '0', HEIGHT_IN: '73', WAIST: '38',
    TCHOL: '185', LDL: '154', HDL: '31', TRIG: '210', FASTING_BG: '170', A1C: '8.8',
    "DIET_VEGGIES": "r_2", "DIET_FRUITS": "r_3", "DIET_WW_GRAINS": "r_3", "DIET_LF_DAIRY": "r_4",
    "DIET_FF_DAIRY": "r_4", "DIET_EGGS": "r_0", "DIET_BEANS": "r_2", "DIET_SEAFOOD": "r_1",
    "DIET_POULTRY": "r_1", "DIET_MEAT": "r_1", "DIET_SNACKS": "r_1", "DIET_FRIED": "r_1",
    "DIET_PASTRY": "r_0", "DIET_EAT_OUT": "r_3", "DIET_HEALTH_FOOD": "r_2",
    "STRESS_PLEASURE": "r_4", "STRESS_DEPRESSED": "r_0", "STRESS_NERVOUS": "r_1", "STRESS_WORRIES": "r_2",
    "STRESS_ANXIETY": "r_4", "STRESS_ANGER": "r_1", "STRESS_COMPETE": "r_0", "STRESS_NO_TIME": "r_2",
    "STRESS_ARGUES": "r_3", "STRESS_ANNOYED": "r_3", "STRESS_SUPPRESSED": "r_3", "STRESS_TEMPER": "r_2",
    "STRESS_AUTONOMY": "r_3", "STRESS_HECTIC": "r_2",
    "PA_HI_FREQ": "r_0", "PA_HI_DUR": "r_3", "PA_MOD_FREQ": "r_1", "PA_MOD_DUR": "r_4",
    "SED_HRS": "r_5", "SED_VIDEO": "r_5", "SED_COMPUTER": "r_5",
});
var test5 = _.extend({}, testBaseF, {
    'EXTERNAL_SURVEY_ID': '5',
    MEDS_ANGINA: 'no', MEDS_BP: 'no', MEDS_CHOL: 'no', MEDS_DM: 'yes',
    PMH_CVD: 'yes', PMH_HTN: 'yes', PMH_CHOL: 'yes', PMH_DM: 'yes',
    BP_SYS: '170', BP_DIA: '100', WEIGHT: '210', HEIGHT_FT: '0', HEIGHT_IN: '71', WAIST: '39',
    TCHOL: '196', LDL: '155', HDL: '41', TRIG: '240', FASTING_BG: '150', A1C: '9.9',
    "DIET_VEGGIES": "r_1", "DIET_FRUITS": "r_2", "DIET_WW_GRAINS": "r_2", "DIET_LF_DAIRY": "r_2",
    "DIET_FF_DAIRY": "r_4", "DIET_EGGS": "r_1", "DIET_BEANS": "r_2", "DIET_SEAFOOD": "r_2",
    "DIET_POULTRY": "r_2", "DIET_MEAT": "r_1", "DIET_SNACKS": "r_1", "DIET_FRIED": "r_1",
    "DIET_PASTRY": "r_3", "DIET_EAT_OUT": "r_3", "DIET_HEALTH_FOOD": "r_2",
    "STRESS_PLEASURE": "r_2", "STRESS_DEPRESSED": "r_3", "STRESS_NERVOUS": "r_0", "STRESS_WORRIES": "r_1",
    "STRESS_ANXIETY": "r_3", "STRESS_ANGER": "r_1", "STRESS_COMPETE": "r_2", "STRESS_NO_TIME": "r_1",
    "STRESS_ARGUES": "r_1", "STRESS_ANNOYED": "r_1", "STRESS_SUPPRESSED": "r_3", "STRESS_TEMPER": "r_4",
    "STRESS_AUTONOMY": "r_0", "STRESS_HECTIC": "r_1",
    "PA_HI_FREQ": "r_7", "PA_HI_DUR": "r_1", "PA_MOD_FREQ": "r_1", "PA_MOD_DUR": "r_1",
    "SED_HRS": "r_1", "SED_VIDEO": "r_1", "SED_COMPUTER": "r_1",
});
var test6 = _.extend({}, testBaseM, {
    'EXTERNAL_SURVEY_ID': '6',
    MEDS_ANGINA: 'no', MEDS_BP: 'no', MEDS_CHOL: 'no', MEDS_DM: 'no',
    PMH_CVD: 'no', PMH_HTN: 'yes', PMH_CHOL: 'yes', PMH_DM: 'no',
    BP_SYS: '190', BP_DIA: '90', WEIGHT: '230', HEIGHT_FT: '0', HEIGHT_IN: '69', WAIST: '40',
    TCHOL: '227', LDL: '186', HDL: '41', TRIG: '270', FASTING_BG: '130', A1C: '10.1',
    "DIET_VEGGIES": "r_0", "DIET_FRUITS": "r_1", "DIET_WW_GRAINS": "r_1", "DIET_LF_DAIRY": "r_3",
    "DIET_FF_DAIRY": "r_3", "DIET_EGGS": "r_2", "DIET_BEANS": "r_3", "DIET_SEAFOOD": "r_3",
    "DIET_POULTRY": "r_0", "DIET_MEAT": "r_2", "DIET_SNACKS": "r_3", "DIET_FRIED": "r_0",
    "DIET_PASTRY": "r_2", "DIET_EAT_OUT": "r_2", "DIET_HEALTH_FOOD": "r_3",
    "STRESS_PLEASURE": "r_0", "STRESS_DEPRESSED": "r_0", "STRESS_NERVOUS": "r_3", "STRESS_WORRIES": "r_1",
    "STRESS_ANXIETY": "r_3", "STRESS_ANGER": "r_1", "STRESS_COMPETE": "r_1", "STRESS_NO_TIME": "r_3",
    "STRESS_ARGUES": "r_3", "STRESS_ANNOYED": "r_2", "STRESS_SUPPRESSED": "r_2", "STRESS_TEMPER": "r_0",
    "STRESS_AUTONOMY": "r_0", "STRESS_HECTIC": "r_2",
    "PA_HI_FREQ": "r_1", "PA_HI_DUR": "r_1", "PA_MOD_FREQ": "r_3", "PA_MOD_DUR": "r_3",
    "SED_HRS": "r_6", "SED_VIDEO": "r_5", "SED_COMPUTER": "r_6",
});
var test7 = _.extend({}, testBaseF, {
    'EXTERNAL_SURVEY_ID': '7',
    MEDS_ANGINA: 'yes', MEDS_BP: 'yes', MEDS_CHOL: 'no', MEDS_DM: 'yes',
    PMH_CVD: 'yes', PMH_HTN: 'yes', PMH_CHOL: 'no', PMH_DM: 'no',
    BP_SYS: '210', BP_DIA: '80', WEIGHT: '250', HEIGHT_FT: '0', HEIGHT_IN: '67', WAIST: '41',
    TCHOL: '238', LDL: '187', HDL: '51', TRIG: '300', FASTING_BG: '120', A1C: '8.4',
    "DIET_VEGGIES": "r_0", "DIET_FRUITS": "r_0", "DIET_WW_GRAINS": "r_1", "DIET_LF_DAIRY": "r_4",
    "DIET_FF_DAIRY": "r_3", "DIET_EGGS": "r_3", "DIET_BEANS": "r_1", "DIET_SEAFOOD": "r_2",
    "DIET_POULTRY": "r_2", "DIET_MEAT": "r_3", "DIET_SNACKS": "r_0", "DIET_FRIED": "r_2",
    "DIET_PASTRY": "r_3", "DIET_EAT_OUT": "r_2", "DIET_HEALTH_FOOD": "r_2",
    "STRESS_PLEASURE": "r_3", "STRESS_DEPRESSED": "r_0", "STRESS_NERVOUS": "r_3", "STRESS_WORRIES": "r_3",
    "STRESS_ANXIETY": "r_4", "STRESS_ANGER": "r_4", "STRESS_COMPETE": "r_2", "STRESS_NO_TIME": "r_3",
    "STRESS_ARGUES": "r_1", "STRESS_ANNOYED": "r_2", "STRESS_SUPPRESSED": "r_1", "STRESS_TEMPER": "r_4",
    "STRESS_AUTONOMY": "r_4", "STRESS_HECTIC": "r_1",
    "PA_HI_FREQ": "r_5", "PA_HI_DUR": "r_5", "PA_MOD_FREQ": "r_1", "PA_MOD_DUR": "r_3",
    "SED_HRS": "r_4", "SED_VIDEO": "r_3", "SED_COMPUTER": "r_1",
});
var test8 = _.extend({}, testBaseM, {
    'EXTERNAL_SURVEY_ID': '8',
    MEDS_ANGINA: 'yes', MEDS_BP: 'yes', MEDS_CHOL: 'no', MEDS_DM: 'yes',
    PMH_CVD: 'no', PMH_HTN: 'no', PMH_CHOL: 'no', PMH_DM: 'no',
    BP_SYS: '230', BP_DIA: '70', WEIGHT: '270', HEIGHT_FT: '0', HEIGHT_IN: '65', WAIST: '42',
    TCHOL: '239', LDL: '208', HDL: '31', TRIG: '330', FASTING_BG: '100', A1C: '6.3',
    "DIET_VEGGIES": "r_0", "DIET_FRUITS": "r_0", "DIET_WW_GRAINS": "r_2", "DIET_LF_DAIRY": "r_1",
    "DIET_FF_DAIRY": "r_2", "DIET_EGGS": "r_1", "DIET_BEANS": "r_1", "DIET_SEAFOOD": "r_1",
    "DIET_POULTRY": "r_2", "DIET_MEAT": "r_3", "DIET_SNACKS": "r_3", "DIET_FRIED": "r_2",
    "DIET_PASTRY": "r_0", "DIET_EAT_OUT": "r_2", "DIET_HEALTH_FOOD": "r_0",
    "STRESS_PLEASURE": "r_3", "STRESS_DEPRESSED": "r_4", "STRESS_NERVOUS": "r_4", "STRESS_WORRIES": "r_0",
    "STRESS_ANXIETY": "r_2", "STRESS_ANGER": "r_2", "STRESS_COMPETE": "r_3", "STRESS_NO_TIME": "r_0",
    "STRESS_ARGUES": "r_3", "STRESS_ANNOYED": "r_2", "STRESS_SUPPRESSED": "r_1", "STRESS_TEMPER": "r_2",
    "STRESS_AUTONOMY": "r_1", "STRESS_HECTIC": "r_1",
    "PA_HI_FREQ": "r_1", "PA_HI_DUR": "r_4", "PA_MOD_FREQ": "r_3", "PA_MOD_DUR": "r_1",
    "SED_HRS": "r_6", "SED_VIDEO": "r_1", "SED_COMPUTER": "r_4",
});
var test9 = _.extend({}, testBaseF, {
    'EXTERNAL_SURVEY_ID': '9',
    MEDS_ANGINA: 'no', MEDS_BP: 'yes', MEDS_CHOL: 'yes', MEDS_DM: 'yes',
    PMH_CVD: 'yes', PMH_HTN: 'yes', PMH_CHOL: 'yes', PMH_DM: 'yes',
    BP_SYS: '250', BP_DIA: '60', WEIGHT: '290', HEIGHT_FT: '0', HEIGHT_IN: '63', WAIST: '43',
    TCHOL: '240', LDL: '209', HDL: '31', TRIG: '360', FASTING_BG: '80', A1C: '4.2',
    "DIET_VEGGIES": "r_3", "DIET_FRUITS": "r_1", "DIET_WW_GRAINS": "r_3", "DIET_LF_DAIRY": "r_4",
    "DIET_FF_DAIRY": "r_3", "DIET_EGGS": "r_0", "DIET_BEANS": "r_1", "DIET_SEAFOOD": "r_0",
    "DIET_POULTRY": "r_1", "DIET_MEAT": "r_2", "DIET_SNACKS": "r_2", "DIET_FRIED": "r_1",
    "DIET_PASTRY": "r_2", "DIET_EAT_OUT": "r_1", "DIET_HEALTH_FOOD": "r_2",
    "STRESS_PLEASURE": "r_3", "STRESS_DEPRESSED": "r_4", "STRESS_NERVOUS": "r_3", "STRESS_WORRIES": "r_3",
    "STRESS_ANXIETY": "r_1", "STRESS_ANGER": "r_4", "STRESS_COMPETE": "r_0", "STRESS_NO_TIME": "r_4",
    "STRESS_ARGUES": "r_2", "STRESS_ANNOYED": "r_1", "STRESS_SUPPRESSED": "r_1", "STRESS_TEMPER": "r_4",
    "STRESS_AUTONOMY": "r_1", "STRESS_HECTIC": "r_1",
    "PA_HI_FREQ": "r_6", "PA_HI_DUR": "r_1", "PA_MOD_FREQ": "r_5", "PA_MOD_DUR": "r_4",
    "SED_HRS": "r_3", "SED_VIDEO": "r_6", "SED_COMPUTER": "r_5",
});
// case to match data that is passed from Conifer test server
// (mostly - note that values for BP, etc. will need to be entered to match those below; DOB is the most important
// factor to ensure correct Framingham score)
var testConifer = _.extend({}, testBaseM, {
    DOB: '1982-01-01',
    MEDS_ANGINA: 'yes', MEDS_BP: 'yes', MEDS_CHOL: 'no', MEDS_DM: 'yes',
    PMH_CVD: 'no', PMH_HTN: 'no', PMH_CHOL: 'no', PMH_DM: 'no',
    BP_SYS: '230', BP_DIA: '70', WEIGHT: '270', HEIGHT_FT: '0', HEIGHT_IN: '65', WAIST: '42',
    TCHOL: '239', LDL: '208', HDL: '31', TRIG: '330', FASTING_BG: '100', A1C: '6.3',
    "DIET_VEGGIES": "r_0", "DIET_FRUITS": "r_0", "DIET_WW_GRAINS": "r_2", "DIET_LF_DAIRY": "r_1",
    "DIET_FF_DAIRY": "r_2", "DIET_EGGS": "r_1", "DIET_BEANS": "r_1", "DIET_SEAFOOD": "r_1",
    "DIET_POULTRY": "r_2", "DIET_MEAT": "r_3", "DIET_SNACKS": "r_3", "DIET_FRIED": "r_2",
    "DIET_PASTRY": "r_0", "DIET_EAT_OUT": "r_2", "DIET_HEALTH_FOOD": "r_0",
    "STRESS_PLEASURE": "r_3", "STRESS_DEPRESSED": "r_4", "STRESS_NERVOUS": "r_4", "STRESS_WORRIES": "r_0",
    "STRESS_ANXIETY": "r_2", "STRESS_ANGER": "r_2", "STRESS_COMPETE": "r_3", "STRESS_NO_TIME": "r_0",
    "STRESS_ARGUES": "r_3", "STRESS_ANNOYED": "r_2", "STRESS_SUPPRESSED": "r_1", "STRESS_TEMPER": "r_2",
    "STRESS_AUTONOMY": "r_1", "STRESS_HECTIC": "r_1",
    "PA_HI_FREQ": "r_1", "PA_HI_DUR": "r_4", "PA_MOD_FREQ": "r_3", "PA_MOD_DUR": "r_1",
    "SED_HRS": "r_6", "SED_VIDEO": "r_1", "SED_COMPUTER": "r_4",
});

// correct scores for test1 - test9
const targetScores = {
    1: {
        'FRAMINGHAM_SCORE': .1049,
        'SCORE_BMI': 2.5,
        'SCORE_CHOL': 25,
        'SCORE_BP': -4,
        'SCORE_METAB': 114.8,
        'SCORE_PMH': 325,
        'SCORE_DIET': 10,
        'SCORE_STRESS': 16.45,
        'SCORE_EXER': -42.857,
        'SCORE_EXER_2': -40.82,
        'SCORE_SED': 2,
        'BIO_BP_SYS': -4,
        'BIO_BP_DIA': 0,
        'BIO_BMI': 2.5,
        'BIO_LDL_NO_CVD': 0,
        'BIO_TC_NO_CVD': 0,
        'BIO_LDL_CVD_OR_DM': 16.5,
        'BIO_TC_CVD_OR_DM': 0,
        'BIO_HDL_MEN': 0,
        'BIO_HDL_WOMEN': 8.5,
        'BIO_TG': 0,
        'BIO_TC_OVER_HDL': 0,
        'BIO_FBG': 95.3,
        'BIO_A1C': -5,
        'BIO_WAIST_MEN': 0,
        'BIO_WAIST_WOMEN': 15,
        'WL_SEVERE_OBESITY': 0,
        'WL_HDL_LOW': 1,
        'WL_LDL_HIGH': 1,
        'WL_BP_HIGH': 0,
        'WL_A1C_ELEVATED': 0,
        'WL_METAB_SYNDROME': 1,
        'WL_VERY_HIGH_RISK': 1,
        'WL_QUIT_SMOKING': 0,
        'WL_TOO_SEDENTARY': 0,
        'WL_STRESS': 0,
        'WL_EAT_MORE_VEGGIES': 1,
        'WL_POOR_DIET': 0,
    },
    2: {
        'FRAMINGHAM_SCORE': .0698,
        'SCORE_BMI': 3.1,
        'SCORE_CHOL': 22.8,
        'SCORE_BP': 12,
        'SCORE_METAB': 108.7,
        'SCORE_PMH': 235,
        'SCORE_DIET': 18.5,
        'SCORE_STRESS': 18.8,
        'SCORE_EXER': 12.314,
        'SCORE_EXER_2': -2.33,
        'SCORE_SED': 2,
        'BIO_BP_SYS': 0,
        'BIO_BP_DIA': 16,
        'BIO_BMI': 3.1,
        'BIO_LDL_NO_CVD': 0,
        'BIO_TC_NO_CVD': 0,
        'BIO_LDL_CVD_OR_DM': 16.75,
        'BIO_TC_CVD_OR_DM': 0,
        'BIO_HDL_MEN': 6,
        'BIO_HDL_WOMEN': 0,
        'BIO_TG': 0,
        'BIO_TC_OVER_HDL': 0,
        'BIO_FBG': 86.7,
        'BIO_A1C': 6,
        'BIO_WAIST_MEN': 0,
        'BIO_WAIST_WOMEN': 0,
        'WL_SEVERE_OBESITY': 0,
        'WL_HDL_LOW': 0,
        'WL_LDL_HIGH': 0,
        'WL_BP_HIGH': 0,
        'WL_A1C_ELEVATED': 0,
        'WL_METAB_SYNDROME': 1,
        'WL_VERY_HIGH_RISK': 1,
        'WL_QUIT_SMOKING': 0,
        'WL_TOO_SEDENTARY': 0,
        'WL_STRESS': 1,
        'WL_EAT_MORE_VEGGIES': 0,
        'WL_POOR_DIET': 1,
    },
    3: {
        'FRAMINGHAM_SCORE': .1779,
        'SCORE_BMI': 4.3,
        'SCORE_CHOL': 30.5,
        'SCORE_BP': 32,
        'SCORE_METAB': 146.5,
        'SCORE_PMH': 65,
        'SCORE_DIET': 11,
        'SCORE_STRESS': 17.39,
        'SCORE_EXER': 25,
        'SCORE_EXER_2': 11.7,
        'SCORE_SED': 6,
        'BIO_BP_SYS': 0,
        'BIO_BP_DIA': 40,
        'BIO_BMI': 4.3,
        'BIO_LDL_NO_CVD': 0,
        'BIO_TC_NO_CVD': 0,
        'BIO_LDL_CVD_OR_DM': 17,
        'BIO_TC_CVD_OR_DM': 0,
        'BIO_HDL_MEN': 0,
        'BIO_HDL_WOMEN': 6,
        'BIO_TG': 7.5,
        'BIO_TC_OVER_HDL': 0,
        'BIO_FBG': 78,
        'BIO_A1C': 17,
        'BIO_WAIST_MEN': 0,
        'BIO_WAIST_WOMEN': 15,
        'WL_SEVERE_OBESITY': 0,
        'WL_HDL_LOW': 0,
        'WL_LDL_HIGH': 0,
        'WL_BP_HIGH': 1,
        'WL_A1C_ELEVATED': 1,
        'WL_METAB_SYNDROME': 1,
        'WL_VERY_HIGH_RISK': 0,
        'WL_QUIT_SMOKING': 0,
        'WL_TOO_SEDENTARY': 0,
        'WL_STRESS': 0,
        'WL_EAT_MORE_VEGGIES': 0,
        'WL_POOR_DIET': 0,
    },
    4: {
        'FRAMINGHAM_SCORE': .1794,
        'SCORE_BMI': 5.0,
        'SCORE_CHOL': 35.8,
        'SCORE_BP': 36,
        'SCORE_METAB': 95.5,
        'SCORE_PMH': 320,
        'SCORE_DIET': 0,
        'SCORE_STRESS': 17.39,
        'SCORE_EXER': 24.714,
        'SCORE_EXER_2': 18.76,
        'SCORE_SED': 48,
        'BIO_BP_SYS': 0,
        'BIO_BP_DIA': 32,
        'BIO_BMI': 5.0,
        'BIO_LDL_NO_CVD': 0,
        'BIO_TC_NO_CVD': 0,
        'BIO_LDL_CVD_OR_DM': 17.25,
        'BIO_TC_CVD_OR_DM': 0,
        'BIO_HDL_MEN': 3.5,
        'BIO_HDL_WOMEN': 0,
        'BIO_TG': 15.0,
        'BIO_TC_OVER_HDL': 0,
        'BIO_FBG': 45,
        'BIO_A1C': 28,
        'BIO_WAIST_MEN': 0,
        'BIO_WAIST_WOMEN': 0,
        'WL_SEVERE_OBESITY': 0,
        'WL_HDL_LOW': 1,
        'WL_LDL_HIGH': 1,
        'WL_BP_HIGH': 1,
        'WL_A1C_ELEVATED': 1,
        'WL_METAB_SYNDROME': 1,
        'WL_VERY_HIGH_RISK': 1,
        'WL_QUIT_SMOKING': 0,
        'WL_TOO_SEDENTARY': 1,
        'WL_STRESS': 0,
        'WL_EAT_MORE_VEGGIES': 0,
        'WL_POOR_DIET': 0,
    },
    5: {
        'FRAMINGHAM_SCORE': .3088,
        'SCORE_BMI': 5.9,
        'SCORE_CHOL': 43.5,
        'SCORE_BP': 40,
        'SCORE_METAB': 112.3,
        'SCORE_PMH': 265,
        'SCORE_DIET': 12,
        'SCORE_STRESS': 14.1,
        'SCORE_EXER': 22.286,
        'SCORE_EXER_2': 0.82,
        'SCORE_SED': 0,
        'BIO_BP_SYS': 28,
        'BIO_BP_DIA': 0,
        'BIO_BMI': 5.9,
        'BIO_LDL_NO_CVD': 0,
        'BIO_TC_NO_CVD': 0,
        'BIO_LDL_CVD_OR_DM': 17.5,
        'BIO_TC_CVD_OR_DM': 0,
        'BIO_HDL_MEN': 0,
        'BIO_HDL_WOMEN': 3.5,
        'BIO_TG': 22.5,
        'BIO_TC_OVER_HDL': -5.48,
        'BIO_FBG': 43.3,
        'BIO_A1C': 39,
        'BIO_WAIST_MEN': 0,
        'BIO_WAIST_WOMEN': 15,
        'WL_SEVERE_OBESITY': 0,
        'WL_HDL_LOW': 0,
        'WL_LDL_HIGH': 0,
        'WL_BP_HIGH': 1,
        'WL_A1C_ELEVATED': 1,
        'WL_METAB_SYNDROME': 1,
        'WL_VERY_HIGH_RISK': 1,
        'WL_QUIT_SMOKING': 0,
        'WL_TOO_SEDENTARY': 0,
        'WL_STRESS': 0,
        'WL_EAT_MORE_VEGGIES': 1,
        'WL_POOR_DIET': 0,
    },
    6: {
        'FRAMINGHAM_SCORE': .1321,
        'SCORE_BMI': 6.8,
        'SCORE_CHOL': 47.8,
        'SCORE_BP': 44,
        'SCORE_METAB': 87,
        'SCORE_PMH': 70,
        'SCORE_DIET': 11.5,
        'SCORE_STRESS': 12.22,
        'SCORE_EXER': 18.286,
        'SCORE_EXER_2': 6.14,
        'SCORE_SED': 12,
        'BIO_BP_SYS': 36,
        'BIO_BP_DIA': 0,
        'BIO_BMI': 6.8,
        'BIO_LDL_NO_CVD': 0,
        'BIO_TC_NO_CVD': 16.75,
        'BIO_LDL_CVD_OR_DM': 0,
        'BIO_TC_CVD_OR_DM': 0,
        'BIO_HDL_MEN': 1,
        'BIO_HDL_WOMEN': 0,
        'BIO_TG': 30,
        'BIO_TC_OVER_HDL': 0,
        'BIO_FBG': 5,
        'BIO_A1C': 41,
        'BIO_WAIST_MEN': 15,
        'BIO_WAIST_WOMEN': 0,
        'WL_SEVERE_OBESITY': 0,
        'WL_HDL_LOW': 0,
        'WL_LDL_HIGH': 0,
        'WL_BP_HIGH': 1,
        'WL_A1C_ELEVATED': 1,
        'WL_METAB_SYNDROME': 1,
        'WL_VERY_HIGH_RISK': 0,
        'WL_QUIT_SMOKING': 0,
        'WL_TOO_SEDENTARY': 0,
        'WL_STRESS': 0,
        'WL_EAT_MORE_VEGGIES': 1,
        'WL_POOR_DIET': 0,
    },
    7: {
        'FRAMINGHAM_SCORE': .2823,
        'SCORE_BMI': 7.8,
        'SCORE_CHOL': 64,
        'SCORE_BP': 44,
        'SCORE_METAB': 92.5,
        'SCORE_PMH': 320,
        'SCORE_DIET': 22,
        'SCORE_STRESS': 17.39,
        'SCORE_EXER': -25.571,
        'SCORE_EXER_2': -26.41,
        'SCORE_SED': 0.5,
        'BIO_BP_SYS': 44,
        'BIO_BP_DIA': 0,
        'BIO_BMI': 7.8,
        'BIO_LDL_NO_CVD': 0,
        'BIO_TC_NO_CVD': 0,
        'BIO_LDL_CVD_OR_DM': 25.5,
        'BIO_TC_CVD_OR_DM': 0,
        'BIO_HDL_MEN': 0,
        'BIO_HDL_WOMEN': 1,
        'BIO_TG': 37.5,
        'BIO_TC_OVER_HDL': -8.3,
        'BIO_FBG': -5,
        'BIO_A1C': 24,
        'BIO_WAIST_MEN': 0,
        'BIO_WAIST_WOMEN': 15,
        'WL_SEVERE_OBESITY': 1,
        'WL_HDL_LOW': 0,
        'WL_LDL_HIGH': 0,
        'WL_BP_HIGH': 1,
        'WL_A1C_ELEVATED': 1,
        'WL_METAB_SYNDROME': 1,
        'WL_VERY_HIGH_RISK': 1,
        'WL_QUIT_SMOKING': 0,
        'WL_TOO_SEDENTARY': 0,
        'WL_STRESS': 0,
        'WL_EAT_MORE_VEGGIES': 1,
        'WL_POOR_DIET': 1,
    },
    8: {
        'FRAMINGHAM_SCORE': .3171,
        'SCORE_BMI': 9,
        'SCORE_CHOL': 79.3,
        'SCORE_BP': 52,
        'SCORE_METAB': 90.5,
        'SCORE_PMH': 320,
        'SCORE_DIET': 22.5,
        'SCORE_STRESS': 16.92,
        'SCORE_EXER': 20.457,
        'SCORE_EXER_2': 4.73,
        'SCORE_SED': 4,
        'BIO_BP_SYS': 52,
        'BIO_BP_DIA': 0,
        'BIO_BMI': 9.0,
        'BIO_LDL_NO_CVD': 0,
        'BIO_TC_NO_CVD': 0,
        'BIO_LDL_CVD_OR_DM': 30.75,
        'BIO_TC_CVD_OR_DM': 0,
        'BIO_HDL_MEN': 3.5,
        'BIO_HDL_WOMEN': 0,
        'BIO_TG': 45,
        'BIO_TC_OVER_HDL': 0,
        'BIO_FBG': -25,
        'BIO_A1C': 3,
        'BIO_WAIST_MEN': 15,
        'BIO_WAIST_WOMEN': 0,
        'WL_SEVERE_OBESITY': 1,
        'WL_HDL_LOW': 0,
        'WL_LDL_HIGH': 0,
        'WL_BP_HIGH': 1,
        'WL_A1C_ELEVATED': 0,
        'WL_METAB_SYNDROME': 1,
        'WL_VERY_HIGH_RISK': 1,
        'WL_QUIT_SMOKING': 0,
        'WL_TOO_SEDENTARY': 0,
        'WL_STRESS': 0,
        'WL_EAT_MORE_VEGGIES': 1,
        'WL_POOR_DIET': 1,
    },
    9: {
        'FRAMINGHAM_SCORE': .5738,
        'SCORE_BMI': 10.3,
        'SCORE_CHOL': 89.5,
        'SCORE_BP': 60,
        'SCORE_METAB': 116.2,
        'SCORE_PMH': 315,
        'SCORE_DIET': 11,
        'SCORE_STRESS': 18.8,
        'SCORE_EXER': -2.429,
        'SCORE_EXER_2': -18.02,
        'SCORE_SED': 4,
        'BIO_BP_SYS': 60,
        'BIO_BP_DIA': 0,
        'BIO_BMI': 10.3,
        'BIO_LDL_NO_CVD': 0,
        'BIO_TC_NO_CVD': 0,
        'BIO_LDL_CVD_OR_DM': 31,
        'BIO_TC_CVD_OR_DM': 0,
        'BIO_HDL_MEN': 0,
        'BIO_HDL_WOMEN': 6,
        'BIO_TG': 52.5,
        'BIO_TC_OVER_HDL': 0,
        'BIO_FBG': -17.3,
        'BIO_A1C': -18,
        'BIO_WAIST_MEN': 0,
        'BIO_WAIST_WOMEN': 15,
        'WL_SEVERE_OBESITY': 1,
        'WL_HDL_LOW': 1,
        'WL_LDL_HIGH': 1,
        'WL_BP_HIGH': 1,
        'WL_A1C_ELEVATED': 0,
        'WL_METAB_SYNDROME': 1,
        'WL_VERY_HIGH_RISK': 1,
        'WL_QUIT_SMOKING': 0,
        'WL_TOO_SEDENTARY': 0,
        'WL_STRESS': 1,
        'WL_EAT_MORE_VEGGIES': 0,
        'WL_POOR_DIET': 0,
    },
    10: {
        'FRAMINGHAM_SCORE': .2700,
        'SCORE_BMI': 9,
        'SCORE_CHOL': 79.3,
        'SCORE_BP': 52,
        'SCORE_METAB': 90.5,
        'SCORE_PMH': 320,
        'SCORE_DIET': 22.5,
        'SCORE_STRESS': 16.92,
        'SCORE_EXER': 20.457,
        'SCORE_EXER_2': 4.73,
        'SCORE_SED': 4,
        'BIO_BP_SYS': 52,
        'BIO_BP_DIA': 0,
        'BIO_BMI': 9.0,
        'BIO_LDL_NO_CVD': 0,
        'BIO_TC_NO_CVD': 0,
        'BIO_LDL_CVD_OR_DM': 30.75,
        'BIO_TC_CVD_OR_DM': 0,
        'BIO_HDL_MEN': 3.5,
        'BIO_HDL_WOMEN': 0,
        'BIO_TG': 45,
        'BIO_TC_OVER_HDL': 0,
        'BIO_FBG': -25,
        'BIO_A1C': 3,
        'BIO_WAIST_MEN': 15,
        'BIO_WAIST_WOMEN': 0,
        'WL_SEVERE_OBESITY': 1,
        'WL_HDL_LOW': 0,
        'WL_LDL_HIGH': 0,
        'WL_BP_HIGH': 1,
        'WL_A1C_ELEVATED': 0,
        'WL_METAB_SYNDROME': 1,
        'WL_VERY_HIGH_RISK': 1,
        'WL_QUIT_SMOKING': 0,
        'WL_TOO_SEDENTARY': 0,
        'WL_STRESS': 0,
        'WL_EAT_MORE_VEGGIES': 1,
        'WL_POOR_DIET': 1,
    },
}
export default {
    data() {
        return {
            coniferFields: coniferFields,
            cases: [
                _.extend({}, base, {name: 'Bad key', KEY: 'bbb'}),
                _.extend({}, base, {name: 'Missing language', LANGUAGE: ''}),
                _.extend({}, base, {name: 'Unsupported language', LANGUAGE: 'de'}),
                _.extend({}, base, {name: 'Bad participant ID (not found)', PARTICIPANT_ID: '9999999'}),
                _.extend({}, base, {name: 'Missing gender', GENDER: ''}),
                _.extend({}, base, {name: 'Missing DOB', DOB: ''}),
                _.extend({}, base, {name: 'Bad gender value', GENDER: 'MALE'}),
                _.extend({}, base, {name: 'Bad DOB value', DOB: 'abcdefg'}),
                _.extend({}, base, {name: 'Bad survey ID (not found)', SURVEY_ID: '99999999999'}),
                // TODO: Bad survey ID (for wrong participant)
                _.extend({}, base, {name: 'New participant/survey, with BP'}),
                _.extend({}, reallySick, {name: 'New participant/survey, worst case'}),
                _.extend({}, test1, {targetIndex: 1, name: 'Scoring Test 1 (Female)'}),
                _.extend({}, test2, {targetIndex: 2, name: 'Scoring Test 2 (Male)'}),
                _.extend({}, test3, {targetIndex: 3, name: 'Scoring Test 3 (Female)'}),
                _.extend({}, test4, {targetIndex: 4, name: 'Scoring Test 4 (Male)'}),
                _.extend({}, test5, {targetIndex: 5, name: 'Scoring Test 5 (Female)'}),
                _.extend({}, test6, {targetIndex: 6, name: 'Scoring Test 6 (Male)'}),
                _.extend({}, test7, {targetIndex: 7, name: 'Scoring Test 7 (Female)'}),
                _.extend({}, test8, {targetIndex: 8, name: 'Scoring Test 8 (Male)'}),
                _.extend({}, test9, {targetIndex: 9, name: 'Scoring Test 9 (Female)'}),
                _.extend({}, testConifer, {targetIndex: 10, name: 'Scoring Test 10 (Conifer)'}),
                _.extend({}, test9, {targetIndex: 11, name: 'Hide I Dont Know option', HIDE_I_DONT_KNOW: 1}),
            ],
            targetScores: targetScores,
        }
    }
}
